export default "__VITE_ASSET__DIJL$3po__"